<template>
  <pt-news-classify class="pt-news-classify__withData"></pt-news-classify>
</template>

<script>
import PtNewsClassify from './index'
export default {
  name: 'pt-news-classify__withData',
  components: {
    'pt-news-classify': PtNewsClassify
  }
}
</script>
